export default __webpack_public_path__ + "static/media/inst_juego3.ec145095.png";